var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#F2F1EE","margin":"auto","text-align":"center","min-height":"100vh"}},[_c('img',{staticStyle:{"width":"80%"},attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }